<template>
  <div class="input_container">
    <van-field v-model="inputValue" type="text" :placeholder="props.labelText">
      <template #right-icon>
        <div style="display: flex; align-items: center; justify-content: right;">
          <img :src="captchaImg" alt="" width="100%" class="iconImage" @click="updateCaptcha" />
        </div>
      </template>
    </van-field>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

const props = defineProps({
  labelText: {
    type: String,
    default: () => ''
  },
  isShowError: {
    type: Boolean,
    default: () => false
  },
  captchaImg: {
    type: String,
  }
})

const isShow = ref(false)
const inputValue = ref('')

const emit = defineEmits(['valueChanged', 'updateCaptcha'])


watch(() => inputValue.value, (newValue: string) => {
  emit('valueChanged', newValue)
});

const updateCaptcha = () => {
  console.log("click")
  emit('updateCaptcha')
}

</script>
<style scoped>
.input_container>>>.van-field {
  border-radius: 5px;
  background: rgb(0, 37, 37);
  border: 0.5px solid rgba(26, 30, 71, 0.5);
  color: #ffffffd9;
  padding: 8px 15px !important;
  margin-top: 10px;
  font-size: 16px;
}

.input_container>>>.van-field__control {
  color: #fff !important;
  padding-left: 10px !important;
}

.input_container>>>.van-field__control::placeholder {
  color: #ffffff66 !important;
}

.input_container>>>.van-field__right-icon {
  color: #ffffff40 !important;
  padding-right: 5%;
  width: 30%;
}

.leftContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.currencyText {
  color: #ffffffa6;
  font-family: monospace;
  padding: 0 5px;
  margin: 0;
}

.leftContainer img {
  width: 25px;
}

.line {
  width: 1px;
  background-color: rgba(255, 255, 255, 0.65);
  height: 15px;
  margin-right: 5px;
}

@media (max-width : 400px) {
  .input_container>>>.van-field {
    font-size: 14px;
  }
}
</style>